/** 
* @name: ui-empty
* @Description: 暂无数据 
* text：显示文案(String类型) 
* imgUrl：缺省图地址(String类型) 
* height：容器(Number类型) 
* imgHeight: 缺省图高度 (Number类型)  
* border: 是否需要边框 (Boolean类型)  
* @Author: liulinmei 
* @Date: 2021-12-13 12:28:46
*/
<template>
  <div
    class="none-data"
    :class="{ border: border }"
    :style="{ height: `${height ? height : 500}px` }"
  >
    <img
      :style="{ height: `${imgHeight ? imgHeight : 177}px` }"
      :src="imgUrl || zanwushuju"
      alt=""
    />
    <p>{{ text || '暂无数据' }}</p>
  </div>
</template>
<script>
export default {
  name: 'NoneData',
  props: {
    text: {
      type: String,
    },
    imgUrl: {
      type: String,
    },
    height: {
      type: Number,
    },
    imgHeight: {
      type: Number,
    },
    border: {
      //是否需要边框
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      zanwushuju:
        'https://shigongbang.oss-cn-hangzhou.aliyuncs.com/app/2021/12/1639382057749.png',
    }
  },
  methods: {},
  mounted() {},
  destroyed() {},
}
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
.none-data {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: #fff;
  p {
    color: #666666;
    font-size: 16px;
    margin-top: 10px;
    margin-bottom: 0 !important;
    line-height: 20px;
  }
}
.border {
  border: 1px solid #e4e7ed;
}
</style>
